export default "__VITE_ASSET__911b4294__"